/* Schneller Weg zur Kasse: Statt das Warenkorb-Formular erst an /cart zu senden
   (Shopify berechnet den Warenkorb dann neu und leitet weiter), geht der Klick
   direkt zu /checkout. Mengen, Gutscheine und Notiz speichert das Theme bereits
   per AJAX. Gibt es noch ungespeicherte Eingaben, bleibt der normale Weg. */
(() => {
  if (window.lkFastCheckout) return;
  window.lkFastCheckout = true;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const hasUnsavedInput = (form) => {
    for (const el of form.querySelectorAll('input[name="updates[]"], input[name^="updates["]')) {
      const initial = el.dataset.initialValue != null ? el.dataset.initialValue : el.defaultValue;
      if (String(el.value) !== String(initial)) return true;
    }
    for (const el of form.querySelectorAll('[name="note"], [name^="attributes["]')) {
      if (el.type === 'checkbox' || el.type === 'radio') {
        if (el.checked !== el.defaultChecked) return true;
      } else if (el.value !== el.defaultValue) {
        return true;
      }
    }
    const code = form.querySelector('[data-lk-code-input]');
    if (code && code.value.trim()) return true;
    const terms = form.querySelector('.cart__terms-checkbox');
    if (terms && !terms.checked) return true;
    return false;
  };

  document.addEventListener('submit', (evt) => {
    if (evt.defaultPrevented) return;
    const form = evt.target;
    if (!(form instanceof HTMLFormElement)) return;
    const submitter = evt.submitter;
    if (!submitter || submitter.name !== 'checkout') return;
    let path = '';
    try { path = new URL(form.action, window.location.href).pathname; } catch (_) { return; }
    if (!/\/cart\/?$/.test(path)) return;
    if (hasUnsavedInput(form)) return;
    evt.preventDefault();
    submitter.classList.add('btn--loading');
    submitter.setAttribute('aria-busy', 'true');
    window.location.assign(root + 'checkout');
  });

  /* Zurück aus der Kasse: Ladezustand am Button wieder entfernen */
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('.cart__checkout.btn--loading').forEach((button) => {
      button.classList.remove('btn--loading');
      button.removeAttribute('aria-busy');
    });
  });
})();
